import { render, staticRenderFns } from "./StaffHeader.vue?vue&type=template&id=527838fe&scoped=true"
import script from "./StaffHeader.vue?vue&type=script&lang=js"
export * from "./StaffHeader.vue?vue&type=script&lang=js"
import style0 from "./StaffHeader.vue?vue&type=style&index=0&id=527838fe&prod&scoped=true&lang=less"
import style1 from "./StaffHeader.vue?vue&type=style&index=1&id=527838fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527838fe",
  null
  
)

export default component.exports